export const asyncRequestAnimationFrame = (): Promise<void> => new Promise(resolve => {
  requestAnimationFrame(() => resolve())
})
